export default {
  'form.required': 'NECESSARIO',
  'input.good': 'Bene',
  //<!-------- header --------!>
  'header.book': 'Volo',
  'header.upgradetobusines': 'Cambia in Partner',
  'header.checkin': 'Riserva',
  'header.manage': 'Bacheca',
  'header.login': 'Login',
  'header.signup': 'Signup',
  'header.dashboard': 'bacheca',
  'header.logout': 'Logout',
  'header.ticket': 'biglietti',
  'header.Booking': 'Prenotazione',
  'header.smarttripsi': 'Smart Tripsi',
  'header.smarttripord': 'Smart Tripord',
  'header.aboutus': 'Chi siamo',
  'header.contactus': 'Contattaci',
  //<!-------- footer --------!>
  'footer.supports': 'I Nostri Supporti',
  'footer.onlinechat': 'Online Chat',
  'footer.customer': 'Assistenza Clienti',
  'footer.reserve': 'Supporto della Prenotazione',
  'footer.fax': 'Fax',
  'footer.email': 'Email: Support.Tripsi.com',
  'footer.services': 'Nostri Servizi',
  'footer.flight': 'Volo',
  'footer.hotel': 'Hotel',
  'footer.tour': 'Tour',
  'footer.who': 'siamo',
  'footer.aboutus': 'Chi siamo',
  'footer.contactus': 'Contattaci',
  'footer.members': 'Membri',
  'footer.board': 'Consiglio di Amministrazione',
  'footer.history': 'Storia',
  'footer.privacypolicy': 'Privacy & Policy',
  'footer.privacy': 'Riservatezza',
  'footer.claim': 'Affermazione',
  'footer.rules': 'Regole',
  'footer.address': 'Indirizzo',
  'footer.subscribe': 'Abbonati alle Notizie',
  'footer.copyright': 'Copyright © 2018 Tripsi Inc, All rights reserved',
  'footer.tourismMagazine': 'Tourism Magazine',
  'footer.customerClub': 'Club dei clienti',
  'footer.ticketGuide': 'Ticket Guide',
  'footer.english': 'Inglese',
  'footer.persian': 'Persiano',
  //<!-------- aboutus --------!>
  'aboutus.tripsi': 'Di Tripsi',
  'aboutus.tripord': 'Di Tripord',
  'aboutus.tripsiAboutus': `Tolo Air Travel and Pilgrimage Service Company ha iniziato la sua attività nel grande settore del turismo nel 1373. Il grande team di Tolo con oltre 25 dipendenti, comprese le vendite a Teheran e l'ufficio tecnico a Shiraz, cerca sempre di fornire i migliori servizi e il software della massima qualità per soddisfare gli attuali fornitori. Questa società ha iniziato la sua attività nel campo dei servizi turistici online con il nome Tripsi nel 1401. La politica del sistema Tripsi si basa sulla soddisfazione dei clienti e delle parti interessate e sulla fornitura di servizi superiori e distintivi ai clienti.`,
  'aboutus.tripordAboutus': `Trip Ord Company ha più di 45 anni di esperienza nel settore del turismo e nello sviluppo di software e fornisce servizi nei settori del pellegrinaggio, salute dei turisti, giovani generazioni, generazioni di mezza età, generazioni adulte e utenti telefonici. La maggior parte delle piattaforme esistenti si concentra principalmente su biglietti aerei e prenotazioni di alloggi, mentre è aumentata la domanda di servizi personalizzati e personalizzati da parte dei viaggiatori. TripOrd crede che ci sia molto potenziale non sfruttato nel mercato dei viaggi online e ha intrapreso un percorso per riempire questi spazi vuoti. Con l'aiuto dell'intelligenza artificiale, abbiamo sviluppato una piattaforma di e-tourism personalizzata in modo che i clienti abbiano accesso a tariffe e opzioni competitive come una dashboard personale, un motore di ricerca personalizzato intelligente, un sistema di fidelizzazione basato su punti Club creativo per un più conveniente e viaggio redditizio. provare`,
  'aboutus.service1_tripsi':
    'Rappresentante di tutte le compagnie aeree nazionali e internazionali',
  'aboutus.service2_tripsi':
    "Agenzia per la vendita di biglietti interurbani all'estero",
  'aboutus.service3_tripsi':
    'Agenzia per la vendita di biglietti esteri in modo sistematico e convenzionato',
  'aboutus.service4_tripsi':
    'Agenzia per la vendita di biglietti nazionali in modo sistematico e noleggiato',
  'aboutus.service5_tripsi': 'Agenzia di biglietti ferroviari internazionali',
  'aboutus.service6_tripsi': "Emissione titoli di partenza dall'estero (SOTO)",
  'aboutus.service7_tripsi':
    'Organizzazione e preparazione di tour nazionali ed esteri',
  'aboutus.service8_tripsi': 'Tenuta di seminari e convegni specialistici',
  'aboutus.service9_tripsi':
    "Fornitura di servizi in materia di visti e servizi dell'ambasciata, inclusi (orario dell'ambasciata e ritiro del passaporto)",
  'aboutus.service10_tripsi':
    'Erogazione servizi di trasferimento formalità aeroportuali (CIP)',
  'aboutus.service11_tripsi':
    "Prenotazioni alberghiere in tutto l'Iran e nel mondo",
  'aboutus.service12_tripsi':
    'Organizzazione di carovane di pellegrinaggi, pellegrinaggi e Umrah sotto la supervisione di Hajj e Pellegrinaggio',
  'aboutus.service1_tripord':
    "Gestisci le liste d'attesa e tieni traccia dei rapporti per monitorare le vendite e le attività di noleggio",
  'aboutus.service2_tripord':
    'La possibilità di combinare tutti i voli con sistemi diversi nella maggior parte di una rotta',
  'aboutus.service3_tripord':
    'Vendita di tariffe generiche o negoziate, modificabili per acquisti di soli voli o prodotti di pacchetti dinamici',
  'aboutus.service4_tripord':
    'Emissione automatica del biglietto e cancellazione dei biglietti emessi',
  'aboutus.service5_tripord':
    'Gestione del marketing in base al tipo di tariffa e alle compagnie aeree',
  'aboutus.service6_tripord':
    'Automatic invoicing: automatic generator of invoices to customers',
  'aboutus.service7_tripord':
    'Scegli più lingue (inglese, farsi, italiano, russo, ecc.)',
  'aboutus.service8_tripord': 'Implementazione di oltre 70 gate aerei',
  'aboutus.service9_tripord':
    'La possibilità di assegnazione del credito agli utenti e pagamento del credito',
  'aboutus.service10_tripord':
    'Calendario super professionale e supporto per fusi orari, festività e ricorrenze',
  'aboutus.service11_tripord': `Fornire esigenze personalizzate di "viaggiatori disabili e anziani" o persone con bisogni speciali`,
  'aboutus.service12_tripord':
    'Accesso del cliente a tariffe e opzioni competitive; Compreso dashboard personale, motore di ricerca personalizzato intelligente, sistema di fidelizzazione basato su punti club creativi',
  'aboutus.service13_tripord':
    'Fornire tutti gli aggiornamenti e le comunicazioni normative',
  'aboutus.address':
    'Teheran, Valiasr Street, sopra Zafaranieh, accanto a Refah Bank, NO 3061, piano 2, unità 6',
  'aboutus.company': 'Azienda Tripsi',
  'aboutus.iranphone': '021-22749095',
  'aboutus.canadaaddress': 'Address : 719-938 HOWS STREET, VANCOUVER',
  'aboutus.canadaphone': '001-7786828070',
  //<!-------- dashboard --------!>
  'dashboard.flightDescriptionTripsi':
    'Acquista voli nazionali e internazionali da Tripsi al miglior prezzo',
  'dashboard.flightDescriptionTripord':
    'Acquista voli nazionali e internazionali da Tripord al miglior prezzo',
  'dashboard.overview': 'Panoramica',
  'dashboard.book': 'PRENOTA',
  'dashboard.search': 'CERCA',
  'dashboard.reserve': 'RILASCIATO',
  'dashboard.staffs': 'personale',
  'dashboard.random': 'CASUALE',
  'dashboard.stats': 'statistiche',
  'dashboard.overalview': 'RIVISIONE GENERALE',
  'dashboard.lastactivities': 'ULTIME ATTIVITÀ',
  'dashboard.opportunities': 'opportunità',
  'dashboard.tickets': 'acquistato',
  'dashboard.open': 'NOTIZIE',
  'dashboard.rating': 'GRADO',
  'dashboard.openrequest': 'RICHIESTE APERTE',
  'dashboard.derik': 'Drik',
  'dashboard.showmore': 'Altro….',
  'dashboard.onlinetickets': 'Biglietto online',
  'dashboard.favoritetrips': 'I miei viaggi preferiti',
  'dumb.amount_of_new_users': 'Numero di nuovi utenti: {amountOfUsers}',
  'dumb.display_width': '<strong>Width: {width}</strong>',
  'dumb.display_height': '<strong>Height: {height}</strong>',
  //<!-------- confirmation --------!>
  'confirmation.reject': 'No',
  'confirmation.confirm': 'Si',
  'confirmation.confirmTitle': 'Conferma',
};
